import { Button } from '@mui/material';
import React from 'react';
import { AccessControlledComponents } from '~/constants';
import useAppContext from '~/hooks/useAppContext';

type ReactButtonProps = React.ComponentProps<typeof Button>;

interface ButtonProps extends ReactButtonProps {
	componentName?: AccessControlledComponents;
}

export const AccessControlledButton = ({ componentName, children, ...props }: ButtonProps) => {
	const { hasComponentAccess } = useAppContext();

	const hasAccess = componentName ? hasComponentAccess(componentName) : true;

	if (hasAccess) {
		return <Button {...props}>{children}</Button>;
	}

	return null;
};
